import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { StatusBadge } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { periodLabel, rupiah } from "@/lib/format";

export function DeleteCustomerButton({ customer, idx, onDone }) {
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setOpen(true);
    setInfo(null);
    setReason("");
    try { setInfo((await api.get(`/customers/${customer.id}/delete-check`)).data); } catch (e) { toast.error(errMsg(e)); setOpen(false); }
  };
  const hasInv = info?.invoices.length > 0;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/customers/${customer.id}/delete`, { reason });
      toast.success(`${customer.name} dipindah ke Tempat Sampah (30 hari)`);
      setOpen(false);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="ghost" className="text-rose-600" onClick={start} data-testid={`customer-delete-${idx}`}><Trash2 className="h-4 w-4" /></Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="customer-delete-dialog">
          <DialogHeader>
            <DialogTitle>Hapus {customer.name}?</DialogTitle>
            <DialogDescription>Pelanggan beserta rekap, catatan hutang, dan riwayat pembayarannya dipindah ke Tempat Sampah selama 30 hari dan bisa dipulihkan. Tindakan tercatat di audit log.</DialogDescription>
          </DialogHeader>
          {!info ? <Loader2 className="h-5 w-5 animate-spin mx-auto" /> : (
            <div className="space-y-3">
              {hasInv && (
                <div className="xl-wrap">
                  <table className="xl">
                    <thead><tr><th>No. Nota</th><th>Periode</th><th className="text-right">Total</th><th>Status</th></tr></thead>
                    <tbody>{info.invoices.map((i) => <tr key={i.id}><td className="font-mono">{i.number}</td><td>{periodLabel(i.period)}</td><td className="num">{rupiah(i.total)}</td><td><StatusBadge status={i.status} /></td></tr>)}</tbody>
                  </table>
                </div>
              )}
              {info.debt_remaining > 0 && <div className="text-sm bg-rose-50 border border-rose-200 text-rose-800 px-3 py-2 rounded-sm" data-testid="customer-delete-debt">Sisa hutang: <b>{rupiah(info.debt_remaining)}</b> ikut dipindah ke Tempat Sampah.</div>}
              <Textarea rows={2} placeholder="Alasan (wajib, min. 5 karakter)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="customer-delete-reason" />
              <Button onClick={submit} disabled={busy || reason.trim().length < 5} className="w-full h-11 bg-rose-600 hover:bg-rose-700" data-testid="customer-delete-confirm">
                {hasInv ? "Batalkan invoice & hapus pelanggan" : "Pindahkan ke Tempat Sampah"}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
